import React, { useState, useEffect, useContext } from 'react'
import { ButtonName } from '../../../config/enums'
import { toast } from 'react-toastify'
import { friendlyMessageFor } from '../../../utility/errorHelper'
import constants from '../../../config/constants'
import { Redirect } from 'react-router'
import { createGift, getGiftBundles } from '../../../services/giftService'
import GiftForm from './giftForm'
import { VendorContext } from '../../../contexts/vendorContext'
import { GiftBundle } from '../../../models/GiftBundle'

const AddGifts = () => {
  const [isSuccessful, setIsSuccessful] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false)
  const [giftBundlesList, setGiftBundlesList] = useState<GiftBundle[]>([])
  const vendorContext = useContext(VendorContext)
  const vendorId = vendorContext?.profile?.vendorId

  useEffect(() => {
    const getBundles = async () => {
      setGiftBundlesList(await getGiftBundles(vendorId!))
    }
    getBundles()
  }, [vendorContext, vendorId])

  const createGiftSubmit = async (
    name: string,
    listingStatus: boolean,
    giftBundleIds: string[],
    imageUrl: string | null
  ) => {
    setIsDisabled(true)
    try {
      if (imageUrl == null) {
        toast.error(constants.alertError.noImageUploaded, { autoClose: false })
        setIsDisabled(false)
      } else {
        createGift(name, listingStatus, giftBundleIds, imageUrl!)
          .then(success => {
            if (success) {
              toast.success(constants.alertMessage.createGiftSuccessful, {
                autoClose: 3000
              })
              setIsSuccessful(true)
            } else {
              toast.error(friendlyMessageFor(''))
            }
          })
          .catch(error => {
            setIsDisabled(false)
            toast.error(friendlyMessageFor(error), { autoClose: false })
          })
      }
    } catch (error) {
      console.log(error)
    }
  }

  if (isSuccessful) {
    return <Redirect to="/vendor/gifts" />
  }
  return (
    <GiftForm
      formCallback={(name, listing, giftBundles, imageUrl) => {
        createGiftSubmit(name, listing, giftBundles, imageUrl)
      }}
      isDisabled={isDisabled}
      formType={ButtonName.add}
      listingStatus={true}
      giftBundles={giftBundlesList}
    />
  )
}

export default AddGifts
